import config from 'config'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import { redirectToPage } from 'srcReact/helpers/history'
import styles from './styles.module.scss'

const InviteMembersSuccessModal = ({
  title,
  link,
  redirectLink,
  redirectReactLink,
  backNavigation = false,
  closeModal
}) => {
  const { t } = useTranslation()
  const {
    common: { isNative }
  } = useSelector((state) => state)

  useEffect(() => {
    return () => {
      if (link) {
        window.location = link
      }
    }
  })

  function redirectOnDone() {
    if (redirectLink) {
      window.location = redirectLink
    } else if (redirectReactLink) {
      redirectToPage(redirectReactLink, isNative, backNavigation)
    } else {
      if (closeModal) {
        closeModal()
      }
    }
  }

  return (
    <React.Fragment>
      <div className={styles.image}>
        <img src={`${config.assetUrl}/images/InviteAnimeTransparent.gif`} alt={t('popinSuccessInvites.text')} />
      </div>
      <h2 className={styles.title}>{title || t('popinSuccessInvites.text')}</h2>
      <Button text={t('global.done')} handleClick={redirectOnDone} />
    </React.Fragment>
  )
}

export default InviteMembersSuccessModal
